import _extends from "@babel/runtime/helpers/esm/extends";
import { ExtendableEventCalendarStore } from '@mui/x-scheduler-headless/use-event-calendar';
import { EventCalendarPremiumLazyLoadingPlugin } from "./plugins/EventCalendarPremiumLazyLoadingPlugin.mjs";
/**
 * Premium version of EventCalendarStore with premium plugins.
 */
export class EventCalendarPremiumStore extends ExtendableEventCalendarStore {
  constructor(parameters, adapter) {
    super(parameters, adapter, 'EventCalendarPremiumStore');
    this.lazyLoading = new EventCalendarPremiumLazyLoadingPlugin(this);
  }
  buildPublicAPI() {
    return _extends({}, super.buildPublicAPI());
  }
}